import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'

import { Text } from '../Text'
import { Row, Column } from '../Grid'

const DaysCalendar = ({ isSearch, appointments }) => {
  return (
    <>
      <DaysCalendarContainer width='100%' justifyContent='flex-start'>
        {appointments.map((appointment, index) => (
          <DaysContainer key={index} isSearch={isSearch}>
            <Row
              justifyContent='center'
              alignItems='center'
              width={isSearch ? '43px' : '50px'}
              height={isSearch ? '45px' : '58px'}
              bg='snow'
              borderRadius='3px'
            >
              <Column justifyContent='center'>
                <Text variant='small' color='#7f8c8d' fontWeight='400'>
                  {appointment.dayName}
                </Text>
                <Text
                  lineHeight={isSearch ? '20px' : 'normal'}
                  mt={isSearch ? '0' : '5px'}
                  variant='tiny'
                  color='black'
                  fontWeight='400'
                >
                  {appointment.date}
                </Text>
              </Column>
            </Row>
          </DaysContainer>
        ))}
      </DaysCalendarContainer>
    </>
  )
}

DaysCalendar.propTypes = {
  appointments: propTypes.array.isRequired
}

const DaysContainer = styled(Column)(
  ({ isSearch }) =>
    `
  ${
    isSearch
      ? `
    @media (max-width: 320px) {
      margin-right: 4px;
    }
    @media (min-width: 321px) {
      margin-right: 12px;
    }
    @media (min-width: 425px) {
      margin-left: 15px;
      margin-right: 0px;
    }
  `
      : 'margin-right: 20px;'
  }

`
)

const DaysCalendarContainer = styled(Row)`
  div:first-child {
    margin-left: 0px;
  }
`

export { DaysCalendar }
